export const colorToHex = (color=0) =>{

    let sColor = '000000' + color.toString(16);
    let hexColor = '#' + sColor.slice(-6)
    return hexColor

}
